import { Injectable } from '@angular/core';
import { WireContourService } from '@3d-scene/common/util/wire-contour-service';
import { MaterialsModel } from '@3d-scene/service/materials.model';
import { LabelingUtils } from './util/labeling-utils';
import { ContainerService } from './container.service';
import { ProjectModel } from '@project/model/project.model';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ProjectDrillingHoleService } from '@project/service/project-drilling-hole.service';
import { ArticleManager } from '@article/manager/article.manager';
import { ProjectHelper } from '@project/helper/project.helper';
import { DynamicConnectionCreator } from './dynamic-connection-creator';
import { CreateLabelingHelper } from '@project/components/label/helper/create-labeling.helper';
import { ArticleMoveManager } from '@project/components/article/manager/article-move.manager';
import { SceneManager } from '../manager/scene.manager';
import { ProjectContentPresenter } from '@shared/presenter/project-content.presenter';
import { CreateNewProjectWithPresetArticlesManager } from '@project/manager/create-new-project-with-preset-articles.manager';
import { LayerManager } from '../manager/layer-manager';
import { CompositeArticleManager } from '@article/manager/composite-article.manager';
import { ArticleLoadingManager } from '@article/service/article-loading.manager';
import { ArticlesVisibilityService } from '@project/components/article/service/articles-visibility.service';
import { BridgeArticleManager } from '@project/components/article/manager/bridge-article.manager';
import { CarrierBlockManager } from '@project/components/article/manager/carrier-block.manager';
import { AttachCodingFingerArticleService } from '@project/components/article/service/attach-coding-finger-article.service';
import { ConnectionFactory } from './connection.factory';
import { LabelingArticleRotationHelper } from '@project/components/label/helper/labeling-article-rotation.helper';
import { ArticlePostParseProcessor } from '@project/components/article/processor/postparse/article-post-parse.processor';
import { ArticleContainerAttachedService } from '@project/components/article/service/article-container-attached.service';
import { ArticleChangedService } from '../service/article-changed.service';
import { ArticleContainerFactory } from './article-container.factory';

@Injectable({providedIn: 'root'})
export class ArticleContainerFactoryInitializer {

  constructor(
    private articleContainerFactory: ArticleContainerFactory,
    private labelingUtils: LabelingUtils,
    private componentUtils: ContainerService,
    private projectModel: ProjectModel,
    private projectModelService: ProjectModelService,
    private projectArticleService: ProjectArticleService,
    private projectMetaElementService: ProjectMetaElementService,
    private projectDrillingHoleService: ProjectDrillingHoleService,
    private articleManager: ArticleManager,
    private projectHelper: ProjectHelper,
    private dynamicConnectionCreator: DynamicConnectionCreator,
    private createLabelingHelper: CreateLabelingHelper,
    private articleMoveManager: ArticleMoveManager,
    private sceneManager: SceneManager,
    private projectContentPresenter: ProjectContentPresenter,
    private createNewProjectWithPresetArticlesManager: CreateNewProjectWithPresetArticlesManager,
    private layerManager: LayerManager,
    private compositeArticleManager: CompositeArticleManager,
    private articleLoadingManager: ArticleLoadingManager,
    private articlesVisibilityService: ArticlesVisibilityService,
    private bridgeArticleManager: BridgeArticleManager,
    private carrierBlockManager: CarrierBlockManager,
    private attachCodingFingerArticleService: AttachCodingFingerArticleService,
    private connectionFactory: ConnectionFactory,
    private labelingArticleRotationHelper: LabelingArticleRotationHelper,
    private articlePostParseProcessor: ArticlePostParseProcessor,
    private articleContainerAttachedService: ArticleContainerAttachedService,
    private articleChangedService: ArticleChangedService,
    private materialsModel: MaterialsModel,
    private wireContourService: WireContourService,
  ) {}

  public initialize() {
    this.articleContainerFactory.initialize(
      this.labelingUtils,
      this.componentUtils,
      this.projectModel,
      this.projectModelService,
      this.projectArticleService,
      this.projectMetaElementService,
      this.projectDrillingHoleService,
      this.articleManager,
      this.projectHelper,
      this.dynamicConnectionCreator,
      this.createLabelingHelper,
      this.articleMoveManager,
      this.sceneManager,
      this.projectContentPresenter,
      this.createNewProjectWithPresetArticlesManager,
      this.layerManager,
      this.compositeArticleManager,
      this.articleLoadingManager,
      this.articlesVisibilityService,
      this.bridgeArticleManager,
      this.carrierBlockManager,
      this.attachCodingFingerArticleService,
      this.connectionFactory,
      this.labelingArticleRotationHelper,
      this.articlePostParseProcessor,
      this.articleContainerAttachedService,
      this.articleChangedService,
      this.materialsModel,
      this.wireContourService,
    );
  }
}
